import styled from "styled-components";
import { FlexBox } from "@brg/ui";
import { LayoutConst } from "../../../../../core";
import { ServiceLink as _ServiceLink } from "../../designer";

export const Wrapper = styled(FlexBox)`
    flex-flow: column;
    margin: 0 auto;
    width: 100%;

    @media(max-width: ${LayoutConst.screen.m}px) {
        width: ${(LayoutConst.projectCard.tablet.w * 4) + LayoutConst.projectCardGap.tablet * 3}px;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        width: calc(100% - 20px);
    }
`;

export const InfoWrapper = styled(FlexBox)`
    width: 858px;
    flex-flow: column;
    padding: 24px 24px 32px 24px;
    background-color: ${({ theme }) => theme.designerPage.noProjectBlock.infoBlock.bg };
    margin-bottom: 48px;

    * {
        font-family: 'Inter', sans-serif;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        padding: 16px 16px 24px 16px;
        margin-bottom: 16px;
    }
    
    @media(max-width: ${LayoutConst.screen.m}px) {
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        margin-bottom: 24px;
        padding: 10px 10px 16px 10px;
    }
`;

export const AvatarContainer = styled.div`
    width: ${({ theme }) => theme.designerPage.noProjectBlock.avatar.size.l}px;
    height: ${({ theme }) => theme.designerPage.noProjectBlock.avatar.size.l}px;

    * {
        color: ${({ theme }) => theme.designerPage.noProjectBlock.avatar.color};
        background-color: ${({ theme }) => theme.designerPage.noProjectBlock.avatar.bg};
    }
`;

export const Name = styled.div`
    font-size: 28px;
    line-height: 34px;
    font-weight: 600;
    color: ${({ theme }) => theme.designerPage.noProjectBlock.infoBlock.color};

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 23px;
        line-height: 27px;
        width: 100%;
        white-space: pre-wrap;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 17px;
        line-height: 22px;
        width: 100%;
        white-space: pre-wrap;
    }
`;

export const InfoMsg = styled.div`
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    width: 100%;
    color: ${({ theme }) => theme.designerPage.noProjectBlock.infoBlock.color};

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 13px;
        line-height: 16px;
    }
`;

export const Title = styled.div`
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    color: ${({ theme }) => theme.designerPage.noProjectBlock.infoBlock.color};
    width: 100%;
    margin-bottom: 24px;

    @media(max-width: ${LayoutConst.screen.m}px) {
        margin: 0 auto 16px auto;
        font-size: 23px;
        line-height: 29px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        margin-bottom: 10px;
        font-size: 20px;
        line-height: 25px;
    }
`;

export const ProjectsWrapper = styled(FlexBox)`
        @media(max-width: ${LayoutConst.screen.m}px) {
            margin: 0 auto;
        }
`;

export const ServiceLinks = styled(FlexBox)`
    flex-grow: 0;
    flex-shrink: 0;
    gap: 8px 16px;
    flex-direction: column;
`

export const ShowMoreMsg = styled.span`
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 17px;
    line-height: 22px;
    color: ${({ theme }) => theme.designerPage.noProjectBlock.infoBlock.color};

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 15px;
        line-height: 20px;
    }
    
    @media(max-width: ${LayoutConst.screen.xsm}px) {
        font-size: 13px;
        line-height: 16px;
    }
`

export const ServiceLinksWrapper = styled(FlexBox)`
    gap: 4px 16px;
    margin-left: 1em;
`

export const ServiceLink = styled(_ServiceLink)`
    color: ${({ theme }) => theme.designerPage?.slideLineInActive || ''};
    font-size: 30px;

    svg:nth-child(2) {
        path {
            fill: currentColor;
        }
    }

    &:hover {
        color: ${({ theme }) => theme.designerPage?.slideLine || ''};

        svg:nth-child(2) {
            path {
                fill: currentColor;
            }
        }
    }
`import styled from "styled-components";
import { FlexBox } from "@brg/ui";
import { LayoutConst } from "../../../../../core";
import { ServiceLink as _ServiceLink } from "../../designer";

export const Wrapper = styled(FlexBox)`
    flex-flow: column;
    margin: 0 auto;
    width: 100%;

    @media(max-width: ${LayoutConst.screen.m}px) {
        width: ${(LayoutConst.projectCard.tablet.w * 4) + LayoutConst.projectCardGap.tablet * 3}px;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        width: calc(100% - 20px);
    }
`;

export const InfoWrapper = styled(FlexBox)`
    width: 858px;
    flex-flow: column;
    padding: 24px 24px 32px 24px;
    background-color: ${({ theme }) => theme.designerPage.noProjectBlock.infoBlock.bg };
    margin-bottom: 48px;

    * {
        font-family: 'Inter', sans-serif;
    }

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        padding: 16px 16px 24px 16px;
        margin-bottom: 16px;
    }
    
    @media(max-width: ${LayoutConst.screen.m}px) {
        width: 100%;
    }

    @media(max-width: ${LayoutConst.screen.s -1}px) {
        margin-bottom: 24px;
        padding: 10px 10px 16px 10px;
    }
`;

export const AvatarContainer = styled.div`
    width: ${({ theme }) => theme.designerPage.noProjectBlock.avatar.size.l}px;
    height: ${({ theme }) => theme.designerPage.noProjectBlock.avatar.size.l}px;

    * {
        color: ${({ theme }) => theme.designerPage.noProjectBlock.avatar.color};
        background-color: ${({ theme }) => theme.designerPage.noProjectBlock.avatar.bg};
    }
`;

export const Name = styled.div`
    font-size: 28px;
    line-height: 34px;
    font-weight: 600;
    color: ${({ theme }) => theme.designerPage.noProjectBlock.infoBlock.color};

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 23px;
        line-height: 27px;
        width: 100%;
        white-space: pre-wrap;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 17px;
        line-height: 22px;
        width: 100%;
        white-space: pre-wrap;
    }
`;

export const InfoMsg = styled.div`
    font-size: 17px;
    line-height: 22px;
    font-weight: 400;
    width: 100%;
    color: ${({ theme }) => theme.designerPage.noProjectBlock.infoBlock.color};

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        font-size: 13px;
        line-height: 16px;
    }
`;

export const Title = styled.div`
    font-size: 30px;
    line-height: 40px;
    font-weight: 600;
    color: ${({ theme }) => theme.designerPage.noProjectBlock.infoBlock.color};
    width: 100%;
    margin-bottom: 24px;

    @media(max-width: ${LayoutConst.screen.m}px) {
        margin: 0 auto 16px auto;
        font-size: 23px;
        line-height: 29px;
    }

    @media(max-width: ${LayoutConst.screen.s - 1}px) {
        margin-bottom: 10px;
        font-size: 20px;
        line-height: 25px;
    }
`;

export const ProjectsWrapper = styled(FlexBox)`
        @media(max-width: ${LayoutConst.screen.m}px) {
            margin: 0 auto;
        }
`;

export const ServiceLinks = styled(FlexBox)`
    flex-grow: 0;
    flex-shrink: 0;
    gap: 8px 16px;
    flex-direction: column;
`

export const ShowMoreMsg = styled.span`
    flex-grow: 0;
    flex-shrink: 0;
    font-size: 17px;
    line-height: 22px;
    color: ${({ theme }) => theme.designerPage.noProjectBlock.infoBlock.color};

    @media(max-width: ${LayoutConst.screen.mac13}px) {
        font-size: 15px;
        line-height: 20px;
    }
    
    @media(max-width: ${LayoutConst.screen.xsm}px) {
        font-size: 13px;
        line-height: 16px;
    }
`

export const ServiceLinksWrapper = styled(FlexBox)`
    gap: 4px 16px;
    margin-left: 1em;
`

export const ServiceLink = styled(_ServiceLink)`
    color: ${({ theme }) => theme.designerPage?.slideLineInActive || ''};
    font-size: 30px;

    svg:nth-child(2) {
        path {
            fill: currentColor;
        }
    }

    &:hover {
        color: ${({ theme }) => theme.designerPage?.slideLine || ''};

        svg:nth-child(2) {
            path {
                fill: currentColor;
            }
        }
    }
`